'use strict';

import type { CommissionStatement } from '../../Entities/CommissionStatement/CommissionStatement';
import { EntityCollection } from '../EntityCollection';

export class CommissionStatementCollection extends EntityCollection<CommissionStatement> {}
